<template>
    <div class="detail-module">
        <div class="box">
            <div class="detail-box">
                <div class="flex flex-between flex-y-center mb-30">
                    <van-checkbox v-model="isCheck" :disabled="getTodoCheckDisabled(detail.remindDate, isCheck, detail.status)"
                        @change="todoCheck(detail.id)">

                    </van-checkbox>
                    <div class="detail-title flex-1">
                        {{detail.message}}
                    </div>
                </div>
                <div v-if="detail.source ==1" class="remind">客人为匿名评价，请勿联系客人!</div>
                <div v-for="(item, index) in detail.contactList" :key="index">
                    <div class="info-remain flex flex-end flex-y-center">
                        <img :src="item.avatar" class="head-icon fl" v-if="item.avatar &&detail.source !=1" alt="" />
                        <div class=" flex-1 flex-y-center ml-20 fl" v-if="item.name&&detail.source !=1 ">
                            {{item.name}}
                        </div>
                        <div class="flex-1 flex-y-center ml-20 fl" v-if="!item.name && detail.source != 1">
                        </div>
                        <div class="flex-1 flex-y-center ml-20 fl" v-else-if="detail.source == 1">工单来源：满意度评价
                        </div>
                        <div class="follow fr" @click="toCustomer(item)" v-if="detail.type ==12">
                            立即处理
                            <van-icon name="arrow" color="#CCCCCC" />
                        </div>
                        <div class="follow fr" @click="toCustomer(item)" v-else>
                            跟进
                            <van-icon name="arrow" color="#CCCCCC" />
                        </div>
                    </div>
                    <!-- 1：院余提醒，2：券余提醒，3：生日提醒，4：消费提醒，5：任务，6：会员流转，7：会员被其他顾问激活，8：会员异店消费，9：专属预约，10：审核提醒，11：当天到店提醒 -->
                    <div v-if="detail.type == 1 ||detail.type == 2">
                        <!-- 院余提醒，券余提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">名称</div>
                            <div class="num">次数/余额</div>
                            <div class="time">过期时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.name}}</div>
                            <div class="num">{{oItem.balance}}</div>
                            <div class="time">{{oItem.endDate}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 3">
                        <!-- 生日提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">名称</div>
                            <div class="arrive-time">生日</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.name}}</div>
                            <div class="arrive-time">{{oItem.birthday}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 4">
                        <!-- 消费提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">名称</div>
                            <div class="arrive-time">最后到店消费时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.name}}</div>
                            <div class="arrive-time">{{oItem.transDate}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 6">
                        <!-- 会员流转 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">姓名</div>
                            <div class="arrive-time">最后到店消费时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.name}}</div>
                            <div class="arrive-time">{{oItem.transDate}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 7">
                        <!-- 会员被其他顾问激活 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">姓名</div>
                            <div class="num">跳卡等级</div>
                            <div class="time">变更顾问</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.custName}}</div>
                            <div class="num">{{oItem.cardClass}}</div>
                            <div class="time">{{oItem.counselor}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 8">
                        <!-- 会员异店消费 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">项目</div>
                            <div class="num">门店</div>
                            <div class="time">消费时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.name}}</div>
                            <div class="num">{{oItem.storeName}}</div>
                            <div class="time">{{oItem.dateTime}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 11 || detail.type == 9 ">
                        <!-- 会员预约到店提醒, 专属预约 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">预约门店</div>
                            <div class="num">预约美疗师</div>
                            <div class="time">预约时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.storeName}}</div>
                            <div class="num">{{oItem.staffName}}</div>
                            <div class="time">{{oItem.dateTime}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 10 ">
                        <!-- 审核提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">审核类型</div>
                            <div class="num">申请人</div>
                            <div class="time">名称/数额</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.auditType}}</div>
                            <div class="num">{{oItem.proposer}}</div>
                            <div class="time">{{oItem.content}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 12 ">
                        <!--工单 -->
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex-col flex-between flex-start">
                            <div class="flex flex-start mb-40">
                                <div class="title" v-if="oItem.workType==1">投诉内容：</div>
                                <div class="title" v-else-if="oItem.workType==2">反馈内容：</div>
                                <div class="flex-1 inner">{{oItem.details}}</div>
                            </div>
                            <div class="flex flex-start">
                                <div class="title">客户诉求：</div>
                                <div class="flex-1 inner">{{oItem.appeal}}</div>
                            </div>

                        </div>
                    </div>
                    <div v-if="detail.type == 13 ">
                        <!-- 新客回访 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">上次护理项目</div>
                            <div class="num">美疗师</div>
                            <div class="time">护理时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.name}}</div>
                            <div class="num">{{oItem.therapists}}</div>
                            <div class="time">{{oItem.dateTime}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 14">
                        <!-- 术后回访 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">术后回访</div>
                            <div class="time">手术时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.shopName}}</div>
                            <div class="time">{{oItem.transDate}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 15">
                        <!-- VIP未到诊提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">上次消费门诊</div>
                            <div class="time">到诊时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.shopName}}</div>
                            <div class="time">{{oItem.transDate}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 16">
                        <!-- 会员未到诊提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">上次消费门诊</div>
                            <div class="time">到诊时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.shopName}}</div>
                            <div class="time">{{oItem.transDate}}</div>
                        </div>
                    </div>
                    <div v-if="detail.type == 17">
                        <!-- 异诊提醒 -->
                        <div class="list-box flex flex-between flex-y-center">
                            <div class="flex-1 name">消费门诊</div>
                            <div class="time">到诊时间</div>
                        </div>
                        <div v-for="(oItem, index) in item.detailList" :key="index"
                            class="list-box list-box-b flex flex-between flex-y-center">
                            <div class="flex-1 name">{{oItem.storeName}}</div>
                            <div class="time">{{oItem.dateTime}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bottom-box flex flex-between flex-y-center">
                <van-icon name="clock-o" class="clock" />
                <div class="flex-1">提醒时间</div>
                <div class="time">{{detail.remindDate}}</div>
            </div>
        </div>
    </div>
</template>
<script>
import request from "@/utils/request";
import { getTodoCheckDisabled } from './utils'
import { Toast } from 'vant'
import { navigateToAddCustomer, openEnterpriseChat, openUserProfile } from '@/utils/wxCodeAuth'

export default {
    name: "toDoDetail",
    data() {
        return {
            isCheck: false,
            id: '',
            detail: {},
        };
    },
    created() {
        this.id = this.$route.query.custId
        // 自定义加载图标
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0, // 持续展示 toast
            loadingType: 'spinner',
        });
        this.getDetail()
    },
    methods: {
        getTodoCheckDisabled,//判断是否勾选
        // 获取详情
        getDetail() {
            request({
                url: `/todo/${this.id}`,
                method: "get",
            })
                .then((res) => {
                    Toast.clear();
                    this.detail = res.data
                    this.isCheck = this.detail.status === 2
                }).catch((error) => {
                    Toast({ position: 'top', message: error ?? '' })
                })
        },
        // 跟进 去顾客 或者打开添加页  item.wxExternalUserid,item.isWxContact,item.name,
        toCustomer(val) {
            const { workType, storeNo, guid } = val
            if ([1, 3].includes(workType)) {
                this.$router.push({ name: 'repairOrderDetail', query: { workNoTypeId: workType, storeNo, guid } });
                return
            }
            // if (val.wxExternalUserid && val.isWxContact == 1)   //是好友有userid，打开会话
            //     openEnterpriseChat('', val.wxExternalUserid, '', '')
            // else
            //跳转至绑定客户界面
            this.$router.push({ name: "customerDetail", query: { custId: val.custId, phone: val.mobile, } });
        },
        todoCheck(todoId) {
            request({
                url: `/todo/${todoId}`,
                method: "put",
            }).catch((error) => {
                Toast({ position: 'top', message: error ?? '' })
            })
        }
    },
};
</script>
<style lang="less" scoped>
::-webkit-scrollbar {
    display: none;
}
.detail-module {
    background-color: #f9fafc;
    height: 100%;
    overflow-y: auto;
    padding: 40px 30px;
}
.box {
    box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 20px;
}
.detail-box {
    width: 690px;
    background: #ffffff;
    border-radius: 20px;
    margin: 0 auto;
    padding: 30px 20px;
}
.detail-title {
    font-size: 28px;
    color: #35434c;
    margin-left: 20px;
    font-weight: 700;
}
:deep(.van-checkbox) {
    margin-bottom: 0 !important;
}
.remind {
    font-size: 24px;
    font-weight: 700;
    color: #f65252;
    margin: 0 0 30px 52px;
}
.info-remain {
    height: 70px;
    background: #e9f2ff;
    border-radius: 4px;
    color: #a0acb5;
    font-size: 28px;
    padding: 12px 20px;
    margin-bottom: 29px;
    .head-icon {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        margin-right: 20px;
    }
    .head-icon-m {
        margin-left: -18px;
    }
}
.list-box {
    font-size: 26px;
    color: #a0acb5;
    margin-bottom: 25px;
    .name {
        margin-left: 10px;
    }
    .num {
        width: 130px;
        margin-right: 75px;
        text-align: center;
    }
    .time {
        width: 150px;
        margin-right: 25px;
        text-align: center;
    }
    .arrive-time {
        margin-right: 25px;
        text-align: center;
    }

    .title {
        width: 135px;
        font-size: 26px;
        font-weight: 700;
        color: #35434c;
    }
    .inner {
        word-break: break-all;
    }
}
.list-box-b {
    color: #35434c;
}
.bottom-box {
    height: 100px;
    border-top: 1px solid #d7d7d7;
    background-color: #fff;
    border-radius: 0 0 20px 20px;
    font-size: 28px;
    color: #35434c;
    padding: 20px 30px;
    .clock {
        font-size: 32px;
        margin-right: 20px;
    }
    .time {
        width: 344px;
        text-align: right;
    }
}

:deep(.van-checkbox__icon) {
    font-size: 32px !important;
}
:deep(.van-checkbox__icon .van-icon) {
    width: 32px;
    height: 32px;
    line-height: 32px;
}
:deep(.van-checkbox__icon--checked .van-icon) {
    background-color: #fff;
    border-color: #a0acb5;
    color: #a0acb5;
}
:deep(.van-toast) {
    background: rgba(195, 33, 33, 0.4) !important ;
}
:deep(.van-toast.van-toast--fail, .van-toast.van-toast--loading) {
    background: #a0acb5 !important ;
    width: 30px !important ;
    min-height: 30px !important ;
}
</style>